import React, { useEffect, useMemo, useState } from "react";
import { useContext } from "react";
import { GlobalContext, LoaderContext } from "@/helpers/contexts/contexts";
import useFetcher from "@/helpers/hooks/useFetcher";
import { Typography } from "@mui/material";

import PostcardCampaignJoined from "../components/PostcardCampaignJoined";
import PageLayout from "@/components/layouts/page/PageLayout";
import { campaignService } from "@/features/campaigns/shared/services/campaignService";
import MuiSearchInput from "@/components/muiCustom/search/MuiSearchInput";

type JoinedDirectMailFilters = {
  pageIndex: number;
  searchKey: string;
  sortBy: string;
  sortByDir: string;
};

type ParticipantData = {
  id?: string | number;
};

const JoinedDirectMailCampaignListPage = () => {
  const { loggedInUser, selectedBrand } = useContext(GlobalContext);
  const loader = useContext(LoaderContext);
  const participantData = loggedInUser?.participantData as
    | ParticipantData
    | undefined;

  const [filters, setFilters] = useState<JoinedDirectMailFilters>({
    pageIndex: 0,
    searchKey: "",
    sortBy: "",
    sortByDir: "",
  });

  const reqData = useMemo(() => {
    return {
      id: selectedBrand?.id,
      userId: loggedInUser?.id,
      page: filters?.pageIndex + 1,
      searchKey: filters?.searchKey || "",
      sortBy: filters?.sortBy || "",
      sortByDir: filters?.sortByDir || "",
      fk_participant_id: participantData?.id,
      campaignCat: "Postcard",
    };
  }, [selectedBrand?.id, loggedInUser?.id, participantData, filters]);

  const { data, isLoading, isValidating } = useFetcher(
    reqData,
    campaignService.postcardReportListing,
    { revalidateOnFocus: false }
  );

  const handlePageChange = (
    _event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      pageIndex: value - 1,
    }));
  };

  const handleSearchChange = (value: string) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      searchKey: value,
      pageIndex: 0,
    }));
  };

  const joinedDirectMailData = data as any;
  const postcardCampaignData = joinedDirectMailData?.joinedCampaign
    ? joinedDirectMailData?.joinedCampaign
    : [];
  const pageCount = joinedDirectMailData?.pageCount || 0;
  const recordsTotal = joinedDirectMailData?.recordsTotal || 0;

  useEffect(() => {
    loader(isLoading || isValidating);
  }, [isLoading, loader, isValidating]);

  const renderPage = () => {
    return (
      <>
        <div className="dashboard participant-dashboard">
          <Typography variant="h5" className="widget-title mb-4 mb-md-auto">
            Direct Mail
          </Typography>
          <div className="row my-3">
            <div className="col-lg-4 offset-lg-8">
              <div className="search-container">
                <MuiSearchInput
                  value={filters.searchKey}
                  onChange={handleSearchChange}
                  name="searchKey"
                  id="searchKey"
                />
              </div>
            </div>
          </div>
          <PostcardCampaignJoined
            joinedCampaigns={postcardCampaignData || []}
            pageCount={pageCount}
            pageIndex={filters.pageIndex}
            onPageChange={handlePageChange}
            recordsTotal={recordsTotal}
            isLoading={isLoading}
          />
        </div>
      </>
    );
  };

  return (
    <>
      <PageLayout className="participant-dashboard-container mx-0 mx-sm-2">
        {renderPage()}
      </PageLayout>
    </>
  );
};

export default JoinedDirectMailCampaignListPage;
